.float-right {
  float: right;
}

.grid-row-with-column-gap {
  display: grid;
  column-gap: 8px;
}
